import apiClient from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api.config";

const DATA_VIEW_ENDPOINTS_BY_MODE = {
  research: {
    list: API_ENDPOINTS.RESEARCH.DATA_VIEW_API,
    detail: API_ENDPOINTS.RESEARCH.DATA_VIEW_DETAIL,
    search: API_ENDPOINTS.RESEARCH.DATA_VIEW_SEARCH,
    companyList: API_ENDPOINTS.RESEARCH.DATA_VIEW_COMPANY_LIST,
    companyDetail: API_ENDPOINTS.RESEARCH.DATA_VIEW_COMPANY_DETAIL,
    companySearch: API_ENDPOINTS.RESEARCH.DATA_VIEW_COMPANY_SEARCH,
    download: API_ENDPOINTS.RESEARCH.DATA_VIEW_DOWNLOAD,
  },
  admin: {
    list: API_ENDPOINTS.ADMIN.DATA_VIEW_API,
    detail: API_ENDPOINTS.ADMIN.DATA_VIEW_DETAIL,
    update: API_ENDPOINTS.ADMIN.DATA_VIEW_UPDATE,
    revert: API_ENDPOINTS.ADMIN.DATA_VIEW_REVERT,
    search: API_ENDPOINTS.ADMIN.DATA_VIEW_SEARCH,
    companyList: API_ENDPOINTS.ADMIN.DATA_VIEW_COMPANY_LIST,
    companyDetail: API_ENDPOINTS.ADMIN.DATA_VIEW_COMPANY_DETAIL,
    companySearch: API_ENDPOINTS.ADMIN.DATA_VIEW_COMPANY_SEARCH,
    download: API_ENDPOINTS.ADMIN.DATA_VIEW_DOWNLOAD,
    mergeCompanies: API_ENDPOINTS.ADMIN.DATA_VIEW_COMPANY_MERGE,
    deleteCompanies: API_ENDPOINTS.ADMIN.DATA_VIEW_COMPANY_DELETE,
    addCompanySources: API_ENDPOINTS.ADMIN.DATA_VIEW_COMPANY_ADD_SOURCES,
    removeCompanySources: API_ENDPOINTS.ADMIN.DATA_VIEW_COMPANY_REMOVE_SOURCES,
  },
};

const getModeEndpoints = (mode = "research") =>
  DATA_VIEW_ENDPOINTS_BY_MODE[mode] || DATA_VIEW_ENDPOINTS_BY_MODE.research;

export const dataViewService = {
  listRecords(params, mode = "research") {
    const endpoints = getModeEndpoints(mode);
    const isCompany = params?.dataset === "company";
    return apiClient.get(isCompany ? endpoints.companyList : endpoints.list, params);
  },

  searchRecords(payload, mode = "research") {
    const endpoints = getModeEndpoints(mode);
    const isCompany = payload?.dataset === "company";
    return apiClient.post(isCompany ? endpoints.companySearch : endpoints.search, payload);
  },

  getRecordDetail(params, mode = "research") {
    const endpoints = getModeEndpoints(mode);
    const isCompany = params?.dataset === "company";
    return apiClient.get(isCompany ? endpoints.companyDetail : endpoints.detail, params);
  },

  getOriginalRecordDetail(params, mode = "admin") {
    const endpoints = getModeEndpoints(mode);
    const isCompany = params?.dataset === "company";
    return apiClient.get(isCompany ? endpoints.companyDetail : endpoints.detail, {
      ...params,
      original: true,
    });
  },

  updateRecordDetail(payload, mode = "research") {
    const endpoints = getModeEndpoints(mode);
    const isCompany = payload?.dataset === "company";
    return apiClient.put(
      isCompany ? endpoints.companyDetail : endpoints.update || endpoints.detail,
      payload
    );
  },

  revertRecordDetail(payload, mode = "admin") {
    const endpoints = getModeEndpoints(mode);
    return apiClient.post(endpoints.revert || endpoints.detail, payload);
  },

  downloadBatch({ dataset, start, end }, mode = "research") {
    const params = new URLSearchParams({
      dataset,
      start: String(start),
      end: String(end),
    });

    return apiClient.downloadFile(
      `${getModeEndpoints(mode).download}?${params.toString()}`,
      `${dataset}_${start}_${end}.csv`
    );
  },

  mergeCompanies(payload, mode = "admin") {
    const endpoints = getModeEndpoints(mode);
    return apiClient.post(endpoints.mergeCompanies, payload);
  },

  deleteCompanies(payload, mode = "admin") {
    const endpoints = getModeEndpoints(mode);
    return apiClient.post(endpoints.deleteCompanies, payload);
  },

  addCompanySources(payload, mode = "admin") {
    const endpoints = getModeEndpoints(mode);
    return apiClient.post(endpoints.addCompanySources, payload);
  },

  removeCompanySources(payload, mode = "admin") {
    const endpoints = getModeEndpoints(mode);
    return apiClient.post(endpoints.removeCompanySources, payload);
  },
};
